"use client";

import { ReactNode, useEffect } from "react";

// this wrapper prevents scroll wheel to change values in numeric text fields (conflict with scrolling on page)

export default function WheelFixWrapper({ children }: { children: ReactNode }) {
  useEffect(() => {
    const handleWheel = (_e: WheelEvent) => {
      const active = document.activeElement as HTMLElement | null;

      if (active?.tagName === "INPUT") {
        const input = active as HTMLInputElement;
        if (input.type === "number") {
          input.blur(); // oder: e.preventDefault()
        }
      }
    };

    document.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return <>{children}</>;
}
